import { PLACEHOLDER_BUTTON__bar } from './PLACEHOLDER_BUTTON__bar';

export function PLACEHOLDER_BUTTON__bar_8_5() {
  return <PLACEHOLDER_BUTTON__bar class_name_button="w-8 h-5" />;
}
